import { AreaFilterOptionInformation } from '@studyportals/search-filters';
import { Area } from './Area';
import FiltersDataPresenter from '@/study-search/presenters/FiltersDataPresenter';

class AreaFilterOptionInformationFactory {
	private filtersDataPresenter = FiltersDataPresenter;
	private areaFilterOptionInformation: AreaFilterOptionInformation[] = [];

	public getAreaFilterInformation(): AreaFilterOptionInformation[] {
		const areas = this.filtersDataPresenter.getAreas();
		this.areaFilterOptionInformation = this.generateAreaFilterOptionInformation(areas);

		return this.areaFilterOptionInformation;
	}

	public getAreaFilterOptionValues(): string[] {
		return this.areaFilterOptionInformation.map((_) => _.optionValue);
	}

	private generateAreaFilterOptionInformation(areas: Area[]): AreaFilterOptionInformation[] {
		return areas.map((_) => new AreaFilterOptionInformation(_.name, _.identity, this.getPath(_.name), _.name, _.countryIdentity));
	}

	private getPath(name: string): string {
		let path = name.toLowerCase().replace(/ /g, '-');
		path = path.replace(/\./g, '');
		path = path.replace(/,/g, '');

		return path;
	}
}

export default new AreaFilterOptionInformationFactory();
